<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container " >
                <template #default>   </template>
                </m-div><m-factor-4 v-bind='{...{"sellerName":"\u062e\u0627\u062a\u0648\u0646 \u06a9\u0627\u0644\u06a9\u0634\u0646","addressProp":"","meliProp":"","signature":"https:\/\/api.khatoncollection.ir\/storage\/icons\/MRZSGJbjlcDElO5eV0xWdTPsN9xtIG9hlHSIOnte.png","secondImageFactor":""},...{}}' :style='""' class="" ></m-factor-4>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mFactor4 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/Factors/Factor4';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mFactor4 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
